let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("h9UUp")).then(() => parcelRequire('8Z6uP'));